export const getColorFromBGColor = (bgColor) => {
  if (bgColor.includes("linear-gradient")) {
    return "var(--theme-text-color)";
  }

  const standardizedColor = standardizeColor(bgColor);
  const bgColorRGB = hexToRgb(standardizedColor);

  if (!bgColorRGB) {
    return "var(--theme-text-color)";
  }

  const r = bgColorRGB.r * 0.2126;
  const g = bgColorRGB.g * 0.7152;
  const b = bgColorRGB.b * 0.0722;
  const perceivedLightness = (r + g + b) / 255;

  return perceivedLightness < 0.5 ? "var(--white__text)" : "var(--black__text)";
};

const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
    : null;
};

const standardizeColor = (str) => {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.fillStyle = str;
  return ctx.fillStyle;
};

